import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			name: 'dashboard',
			component: Home,
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/file-extraction',
			name: 'file-extraction',
			component: () => import('./views/file-extraction'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/extracted-data',
			name: 'extracted-data',
			component: () => import('./views/extracted-data'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/rejected-meta',
			name: 'rejected-meta',
			component: () => import('./views/rejected-meta'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/reject-meta-two',
			name: 'reject-meta-two',
			component: () => import('./views/reject-meta-two'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/reword-extracted-data',
			name: 'reword-extracted-data',
			component: () => import('./views/rework-extracted-data'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/stockist-mapping',
			name: 'stockist-mapping',
			component: () => import('./views/stockist-mapping'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/identify-stockist',
			name: 'identify-stockist',
			component: () => import('./views/identify-stockist'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/file-meta',
			name: 'file-meta',
			component: () => import('./views/file-meta'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/ai-meta-map',
			name: 'ai-meta-map',
			component: () => import('./views/ai-meta-map'),
			meta: { policy: [10, 20, 25, 30] },
		},
		{
			path: '/end-points',
			name: 'end-points',
			component: () => import('./views/requests'),
			meta: { policy: [10] },
		},
	],
});
